<div class="topdiv" >

      <div class="agGridOuterDiv">
        <div >
        <div>
            <mat-toolbar class="agGridtoperDiv card" style="
                    background: rgb(228 227 230 / 41%);border-top: 1px solid #a9a9a9a8;
            border-right: 1px solid #a9a9a9a8;
            border-left: 1px solid #a9a9a9a8;">
    
                        <label i18n="@@spmsUserReg" class="textColour">MDL Script List</label>
                        
                        <span class="example-spacer"></span>
              
                        <button class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" [style.background-color]="buttonColor" title="Download" (click) = "onBtExport()">Download
                          <em style="padding: 0px 0px 0px 10px;" class="fas fa-download example-icon" title="Download"></em>
                  </button>
                    <div class="insertPageNoDiv">
                        <mat-form-field appearance="outline">
                            <mat-label i18n="@@spmsUserRegpageno">Page No</mat-label>
                            <input matInput type="text" (input)="onSearchChange($event.target.value)">
                        </mat-form-field>
                    </div>
    
                    <div class="selectRecordsDiv" style="width:9.5%">
                        <mat-form-field appearance="outline" style="width:100%">
                            <mat-label i18n="@@spmsUserRegrecords" style="color:black">Records</mat-label>
                            <mat-select [(ngModel)]="pagesize" (ngModelChange)="onPageSizeChanged()">
                                <mat-option value="10" selected>10</mat-option>
                                <mat-option value="200">200</mat-option>
                                <mat-option value="300">300</mat-option>
                                <mat-option value="400">400</mat-option>
                            </mat-select>
    
                        </mat-form-field>
                    </div>
                    <div class="card pagination paginationFirstButton paginationFirstlastButton">
                        <em class="fas fa-angle-double-left waves-effect waves-light" (click)="onBtFirst()"></em>
                    </div>
                    <div class="card pagination paginationButtons btn-rounded">
                        <ul>
                            <li class="paginationliicon"><em class="fas fa-angle-left waves-effect waves-light"
                                    (click)="onBtPrevious()"></em></li>
                            <li>{{currentpage}}/{{totalpages}}</li>
                            <li class="paginationliicon" style="padding:0;"><em
                                    class="fas fa-angle-right waves-effect waves-light" (click)="onBtNext()"></em></li>
                        </ul>
                    </div>
                    <div class="card pagination paginationLastButton paginationFirstlastButton">
                        <em class="fas fa-angle-double-right waves-effect waves-light" (click)="onBtLast()"></em>
                    </div>
                  </mat-toolbar>
                </div>
        <ag-grid-angular class="ag-theme-balham table-width tablestyles square scroolbar-dusty-grass square thin"
      [columnDefs]="columnDefs"  [animateRows]="true"
      [pagination]="true" [defaultColDef]="defaultColDef" [suppressPaginationPanel]="true" [rowHeight]="35"
      [headerHeight]="35" [enableBrowserTooltips]="true" [floatingFiltersHeight]="45"
      [paginationPageSize]="paginationPageSize" [paginationNumberFormatter]="paginationNumberFormatter"
      [enableRangeSelection]="true" [debug]="true" [rowClassRules]="rowClassRules"
      (paginationChanged)="onPaginationChanged()" [components]="components"
      (gridReady)="onGridReady($event)" [hidden]="!true" style="height: 30vh;margin-bottom: 3%;">
  </ag-grid-angular>
</div>
  <div class="row topRowMargins headerStyle" style="margin-top: 0;">
    <div  style="margin-left: 15px;">
      <label class="textColour" *ngIf="!onEditButton">Edit Script</label>
    </div>
  </div> 

      <form novalidate [formGroup]='validations_form'> 

        <div *ngIf="!onEditButton" class="overlay">
                      <div class="popup">
                
                     <div class="col-lg" style="text-align: end">

         <mat-form-field appearance="outline">
              <mat-label>Property Category</mat-label>

              <mat-select formControlName="propertycategory" [(ngModel)]="attributeObject.propertycategory"
               >
                <mat-option *ngFor="let data of JsuiteCategoryData" [value]="data">
                  {{data}}
                </mat-option>


              </mat-select>
                              </mat-form-field>
</div>
          <div class="col-lg" style="text-align: end">
                <mat-form-field appearance="outline">
              <mat-label>Property Name</mat-label>
              <mat-select formControlName="propertyname" placeholder="Property Name" [(ngModel)]="attributeObject.propertyname"
              >
                <mat-option *ngFor="let data of propertyData" [value]="data.propertyname">
                  {{data.propertyname}}
                </mat-option>

              </mat-select>
                </mat-form-field>
            </div> 
           
                <div class="col-lg" style="text-align: end">

            <mat-form-field appearance="outline">
              <mat-label>Component Type</mat-label>
              <mat-select formControlName="component_type" placeholder="Component Type"
                [(ngModel)]="attributeObject.component_type">
                <mat-option *ngFor="let data of componentTypeData" [value]="data">
                  {{data}}
                </mat-option>

              </mat-select>
              


            </mat-form-field>
          </div>

          <div class="col-lg" style="text-align: end">
            <mat-form-field appearance="outline">
              <mat-label>MDL Template Create</mat-label>
              <textarea matInput type="text" placeholder="MDL Template Create" formControlName="createmdltemplate"
                [(ngModel)]="attributeObject.createmdltemplate"></textarea>
             

            </mat-form-field>
        </div>
                   <!-- <div class="row" style="margin-top: 10px;"> -->

        <!-- </div> -->

          <div class="col-lg" style="text-align: end">
                <mat-form-field appearance="outline">
                <mat-label i18n="@@TMSTAFFMASTERfirstname">Execution Order</mat-label>
                <input matInput type="text" placeholder="Execution Order" formControlName="executionorder"
                    [(ngModel)]="attributeObject.executionorder" maxlength="100">
             
                </mat-form-field>
            </div> 
         <div class="col-lg">
            <div class="radio-group-container">
              <mat-checkbox class="example-margin" formControlName="isexecutable" [(ngModel)]="attributeObject.isexecutable"
                ></mat-checkbox>
              <label>Is Executable</label>
            </div>
        </div>
            
                <div *ngIf="!onEditButton" class="col-lg-3" >
                  <button i18n="@@TMRunButton" type="button" (click)="addWhere()" [style.background-color]="buttonColor"
                  class="actionButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
                  style="padding: .3rem 0.5rem;font-size: .85rem;width:40%;">Update</button>
                  <!-- <button i18n="@@TMRunButton" type="button" (click)="cancelEdit()" [style.border-color]="buttonColor"
                  class="actionButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
                  style="padding: .3rem 0.5rem;font-size: .85rem;width:40%;">Cancel</button> -->
                  <button i18n="@@TMRunButton" type="button" (click)="cancelEdit()" [style.border-color]="buttonColor"
                class="cancelButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
                style="padding: .3rem 0.5rem;font-size: .85rem;width:40%">Cancel</button>
                  </div>
        </div>
      </div>
        </form>
    <div class="col-lg">
        <div class="container" style="text-align: center; margin-left: 25px;">
          <div class="row topRowMargins">
            <div class="col-lg-3"></div>
            <div class="col-lg-5">
            </div>
            <div class="col-lg-2">
              <button i18n="@@TMRunButton" type="button" (click)="saveAttributes()" [style.background-color]="buttonColor"
                class="actionButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
                style="padding: .3rem 1.5rem;font-size: .85rem;width:100%;">Save</button>
            </div>
            <div class="col-lg-2">
              <button i18n="@@TMRunButton" type="button" (click)="cancel()" [style.border-color]="buttonColor"
                class="cancelButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
                style="padding: .3rem 1.6rem;font-size: .85rem;width:100%;">Cancel</button>
            </div>
    
          </div>
        </div>
      </div>
    </div>
    </div>